import { useContext } from 'react';
import { Context } from '../api/userPreferences/context';
import { GRID_DENSITY_MAP, FONT_SIZE_MAP, FONT_WEIGHT_MAP } from '../api/userPreferences/types';

export default function useUserPreferences() {
    const { preferences, loading, loaded, fetch, update, updateColumnState, updateColumnWidths } =
        useContext(Context);

    const { rowHeight, headerHeight } = GRID_DENSITY_MAP[preferences.gridDensity] || GRID_DENSITY_MAP.compact;
    const fontSize = FONT_SIZE_MAP[preferences.fontSize] || FONT_SIZE_MAP.medium;
    const fontWeight = FONT_WEIGHT_MAP[preferences.fontWeight] || FONT_WEIGHT_MAP.normal;

    return {
        preferences,
        loading,
        loaded,
        fetch,
        update,
        updateColumnState,
        updateColumnWidths,
        rowHeight,
        headerHeight,
        fontSize,
        fontWeight,
        getColumnState: (pageKey: string) => preferences.columnStates?.[pageKey] || null,
        /**
         * The widths this user set by hand on `pageKey`, or null if they never
         * did — in which case the grid auto-sizes to content. Never falls back
         * to `columnStates`' widths; see `UserPreferences.columnWidths`.
         */
        getColumnWidths: (pageKey: string) => {
            const widths = preferences.columnWidths?.[pageKey];
            return widths && Object.keys(widths).length > 0 ? widths : null;
        }
    };
}
